window.HywellBundleMount=() => {
  'use strict';
  const $ = selector => document.querySelector(selector);
  const money = BundleCatalogue.money;
  window.HywellBundleMarqueeCleanup?.();
  window.BundleCustomerReviews?.mount();
  const {products,bundles}=BundleCatalogue;
  const siteHeader=$('#hywell-store-header');
  if(siteHeader){
    let cartLink=siteHeader.querySelector('.t4s-site-nav__cart > a, .hywell-site-cart > button');
    const cartHost=cartLink.parentElement;
    cartHost.classList.replace('t4s-site-nav__cart','hywell-site-cart');
    if(cartLink.tagName==='A'){
      const button=document.createElement('button');
      button.type='button';button.className='hywell-cart-trigger';button.innerHTML=cartLink.innerHTML;
      cartLink.replaceWith(button);cartLink=button;
    }
    cartLink.id='bag-button';
    cartLink.setAttribute('aria-label','Open cart');
    cartLink.querySelector('[data-cart-count],#bag-count').id='bag-count';
    const menuTrigger=siteHeader.querySelector('[data-menu-drawer]');
    menuTrigger.setAttribute('aria-label','Open navigation');
    if(window.HywellNativeHeader){
      // Native Kalles handles menus, search, account and the announcement slider.
      // This badge belongs to the pictured bundles in this page's drawer.
      $('#bag-count').removeAttribute('data-cart-count');
    }else{
      menuTrigger.setAttribute('aria-controls','site-menu-dialog');
      menuTrigger.setAttribute('aria-expanded','false');
      $('#site-menu-links').innerHTML=siteHeader.querySelector('.t4s-nav__ul').outerHTML;
      $('#site-menu-dialog').addEventListener('close',()=>menuTrigger.setAttribute('aria-expanded','false'));
      if(!siteHeader.dataset.bundleMounted){
        menuTrigger.addEventListener('click',event=>{
          event.preventDefault();event.stopImmediatePropagation();
          $('#site-menu-dialog').showModal();menuTrigger.setAttribute('aria-expanded','true');
        },true);
        const slides=[...siteHeader.querySelectorAll('.t4s-announcement-bar__item')];
        let slide=0;
        slides.forEach((item,index)=>{item.hidden=index!==0;});
        const options=JSON.parse(siteHeader.querySelector('[data-flickityt4s-js]')?.dataset.flickityt4sJs||'{}');
        if(slides.length>1&&options.autoPlay&&!window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches){
          const timer=window.setInterval(()=>{
            if(!siteHeader.isConnected){window.clearInterval(timer);return;}
            if(document.hidden||siteHeader.matches(':hover')||siteHeader.contains(document.activeElement))return;
            slides[slide].hidden=true;slide=(slide+1)%slides.length;slides[slide].hidden=false;
          },options.autoPlay);
        }
        siteHeader.dataset.bundleMounted='true';
      }
    }
  }
  const cartDrawer=BundleCartDrawer.create();
  let nextRowId=0;
  const makeRow=(product,quantity=0)=>({key:nextRowId++,id:product.id,color:product.defaultColor,size:'M',quantity});
  let rows=products.map(product=>makeRow(product));
  let selectionName='Your custom bundle';
  const getProduct=id=>products.find(product=>product.id===id);
  const selectionKey='hywell-bundle-builder-v1';
  const checkoutReturnKey='hywell-bundle-return-to-builder-v1';
  let returnToBuilderPending=false;
  try{returnToBuilderPending=window.sessionStorage.getItem(checkoutReturnKey)==='1';}catch{}
  // Restore the model, not just browser-restored form values, after checkout.
  try{
    const saved=JSON.parse(window.sessionStorage.getItem(selectionKey));
    if(saved?.version===1&&Array.isArray(saved.rows)&&saved.rows.length>=products.length&&saved.rows.every(row=>{
      const product=getProduct(row.id);
      return product&&product.colors.includes(row.color)&&['M','L','XL'].includes(row.size)&&Number.isInteger(row.quantity)&&row.quantity>=0&&row.quantity<=99;
    })){
      let restored=saved.rows;
      if(saved.layout!=='style-selectors'){
        // Move legacy extra choices into unused slots; keep all active choices.
        restored=saved.rows.slice(0,products.length);
        for(const extra of saved.rows.slice(products.length)){
          const unused=restored.findIndex(row=>row.quantity===0);
          if(unused>=0)restored[unused]=extra;else restored.push(extra);
        }
      }
      rows=restored.map(row=>({...makeRow(getProduct(row.id),row.quantity),color:row.color,size:row.size}));
    }
  }catch{/* Storage can be disabled; the builder must still work. */}
  const imageFor=(product,color)=>window.HywellBundleAssets['products/'+product.images[color]+'.jpg'];
  const colorPreview=product=>{
    const colors=product.id==='boot'?['Grey','Green','Black']:[...product.colors.filter(color=>color!==product.defaultColor),product.defaultColor];
    return `<span class="sock-colors cycle-${colors.length}" data-product="${product.id}"><img class="sock-default" src="${imageFor(product,product.defaultColor)}" alt="${product.name} merino wool socks, available in ${colors.join(', ')}" loading="lazy" width="220" height="220">${colors.length>1?colors.map((color,index)=>`<img class="sock-color-frame" src="${imageFor(product,color)}" data-color="${color}" alt="" aria-hidden="true" loading="eager" decoding="async" width="220" height="220" style="--color-delay:${index}s">`).join(''):''}</span>`;
  };
  const getQuote=()=>BundlePricing.quote(rows.map(row=>({price:getProduct(row.id).price,quantity:row.quantity})));
  const contents=quantities=>quantities.map((quantity,i)=>quantity?`${quantity} ${products[i].name}`:null).filter(Boolean).join(' + ');

  $('#bundle-grid').innerHTML=bundles.map(bundle=>{
    const quote=BundlePricing.quote(bundle.quantities.map((quantity,i)=>({price:products[i].price,quantity})));
    return `<article class="bundle-card ${bundle.id} ${bundle.featured?'featured':''}"><div class="bundle-media"><span class="card-kicker">${bundle.kicker}</span><span class="card-discount">${quote.discountPercent}% OFF</span>${bundle.quantities.map((quantity,i)=>quantity?`<div class="sock-group">${colorPreview(products[i])}<small aria-label="${quantity} pairs">${quantity}X</small></div>`:'').join('')}</div><div class="bundle-content"><h3>${bundle.name}</h3><p class="bundle-description">${bundle.description}</p><div class="bundle-bottom"><div class="bundle-prices"><strong>${money(quote.total)}</strong><del>${money(quote.subtotal)}</del><small>Save ${money(quote.savings)}</small></div><button type="button" class="select-bundle" data-bundle="${bundle.id}" aria-label="Add ${bundle.name} to cart">Add to Cart</button></div></div></article>`;
  }).join('');


  function renderRows() {
    $('#product-rows').innerHTML=rows.map((row,index)=>{
      const product=getProduct(row.id);
      const label=`Selection ${index+1}`;
      return `<div class="product-row" data-row="${row.key}" role="group" aria-label="${label}"><img class="product-thumb" src="${imageFor(product,row.color)}" alt="${row.color} ${product.name} socks" width="85" height="105"><div class="product-row-main"><div class="product-top"><label class="product-style-field" for="style-${row.key}"><span class="sr-only">${label} sock style</span><select id="style-${row.key}" class="product-style-select" data-field="id" aria-label="${label} sock style">${products.map(option=>`<option value="${option.id}" ${option.id===row.id?'selected':''}>${option.name} Merino Socks</option>`).join('')}</select><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></label><small>${money(product.price)} / pair</small></div><div class="row-controls"><label><span class="field-label">Color</span><select data-field="color" aria-label="${label} color">${product.colors.map(color=>`<option ${color===row.color?'selected':''}>${color}</option>`).join('')}</select></label><label><span class="field-label">Size</span><select data-field="size" aria-label="${label} size">${['M','L','XL'].map(size=>`<option ${size===row.size?'selected':''}>${size}</option>`).join('')}</select></label><div class="quantity-field"><label class="field-label" for="quantity-${row.key}">Pairs</label><span class="quantity-control"><button type="button" data-delta="-1" aria-label="Remove one pair from ${label.toLowerCase()}" ${row.quantity===0?'disabled':''}>−</button><input id="quantity-${row.key}" type="number" min="0" max="99" step="1" inputmode="numeric" data-field="quantity" value="${row.quantity}" aria-label="${label} pairs"><button type="button" data-delta="1" aria-label="Add one pair to ${label.toLowerCase()}" ${row.quantity>=99?'disabled':''}>＋</button></span></div></div>${index>=products.length?`<button type="button" class="remove-selection remove-extra-selection" data-remove aria-label="Remove ${label.toLowerCase()}"><span aria-hidden="true">×</span> Remove selection</button>`:''}</div></div>`;
    }).join('');
    updateSummary();
  }

  function updateSummary() {
    const quote=getQuote();
    try{
      window.sessionStorage.setItem(selectionKey,JSON.stringify({version:1,layout:'style-selectors',rows:rows.map(({id,color,size,quantity})=>({id,color,size,quantity}))}));
    }catch{/* Keep in-memory selection usable when storage is unavailable. */}

    $('#summary-count').textContent=`${quote.quantity} ${quote.quantity===1?'pair':'pairs'} selected`;
    $('#summary-subtotal').textContent=money(quote.subtotal);
    $('#summary-total').textContent=money(quote.total);
    $('#summary-total-comparison').hidden=quote.savings===0;
    $('#summary-original').textContent=money(quote.subtotal);
    $('#summary-saving-amount').textContent=money(quote.savings);
    $('#review-button').disabled=quote.quantity===0;
    $('#progress-bar').style.width=Math.min(100,quote.quantity/10*100)+'%';
    $('#progress-message').textContent=quote.nextTier?`Add ${quote.nextTier.quantity-quote.quantity} more ${quote.nextTier.quantity-quote.quantity===1?'pair':'pairs'} to unlock ${quote.nextTier.percent}% savings.`:'Your best bundle savings are unlocked. Enjoy 30% off.';
    $('#mini-tiers').querySelectorAll('[data-tier]').forEach(element=>{const threshold=Number(element.dataset.tier);element.classList.toggle('unlocked',threshold<=quote.quantity);element.classList.toggle('current',threshold<=quote.quantity&&((quote.quantity<5&&threshold===3)||(quote.quantity>=5&&quote.quantity<10&&threshold===5)||(quote.quantity>=10&&threshold===10)));});
    $('#summary-items').innerHTML=rows.map((row,index)=>row.quantity>0?`<div class="summary-item"><span>${row.quantity} × ${getProduct(row.id).name} · ${row.color} · ${row.size}</span><span class="summary-item-prices"><strong>${money(quote.lineTotals[index])}</strong>${quote.savings?`<del>${money(row.quantity*getProduct(row.id).price)}</del>`:''}</span></div>`:'').join('') || '<p>Choose your first pair to get started.</p>';
    $('#mobile-count').textContent=quote.quantity?`${quote.quantity} pairs · ${quote.discountPercent}% savings`:'0 pairs · build your bundle';
    $('#mobile-total').textContent=money(quote.total);
    $('#live-status').textContent=`${quote.quantity} pairs. ${quote.discountPercent}% savings. Bundle total ${money(quote.total)}.`;
  }

  $('#bundle-grid').addEventListener('click',event=>{
    const button=event.target.closest('[data-bundle]');
    if(!button)return;
    cartDrawer.addBundle(button.dataset.bundle);
  });

  $('#product-rows').addEventListener('click',event=>{
    const container=event.target.closest('[data-row]');
    if(!container)return;
    const row=rows.find(item=>item.key===Number(container.dataset.row));
    const deltaButton=event.target.closest('[data-delta]');
    if(deltaButton&&!deltaButton.disabled){row.quantity=Math.max(0,Math.min(99,row.quantity+Number(deltaButton.dataset.delta)));selectionName='Your custom bundle';container.querySelector('input').value=row.quantity;container.querySelector('[data-delta="-1"]').disabled=row.quantity===0;container.querySelector('[data-delta="1"]').disabled=row.quantity===99;updateSummary();}
    if(event.target.closest('[data-remove]')&&rows.indexOf(row)>=products.length){const index=rows.indexOf(row);rows=rows.filter(item=>item!==row);selectionName='Your custom bundle';renderRows();const next=rows[Math.min(index,rows.length-1)];$(`[data-row="${next.key}"] [data-field="id"]`).focus();}
  });

  $('#product-rows').addEventListener('change',event=>{
    const field=event.target.dataset.field;
    if(!field)return;
    const container=event.target.closest('[data-row]');
    const row=rows.find(item=>item.key===Number(container.dataset.row));
    if(field==='quantity'){
      const value=Number(event.target.value);
      row.quantity=Number.isFinite(value)?Math.max(0,Math.min(99,Math.floor(value))):0;
      event.target.value=row.quantity;
      container.querySelector('[data-delta="-1"]').disabled=row.quantity===0;
      container.querySelector('[data-delta="1"]').disabled=row.quantity===99;
      selectionName='Your custom bundle';
    }else if(field==='id'){
      const product=getProduct(event.target.value);
      if(!product)return;
      row.id=product.id;
      if(!product.colors.includes(row.color))row.color=product.defaultColor;
      selectionName='Your custom bundle';renderRows();
      $(`[data-row="${row.key}"] [data-field="id"]`).focus();
      return;
    }else{row[field]=event.target.value;const image=container.querySelector('img');image.src=imageFor(getProduct(row.id),row.color);image.alt=`${row.color} ${getProduct(row.id).name} socks`;}
    updateSummary();
  });

  $('#product-rows').addEventListener('input',event=>{
    if(event.target.dataset.field!=='quantity')return;
    const container=event.target.closest('[data-row]');
    const row=rows.find(item=>item.key===Number(container.dataset.row));
    const value=Number(event.target.value);
    row.quantity=Number.isFinite(value)?Math.max(0,Math.min(99,Math.floor(value))):0;
    container.querySelector('[data-delta="-1"]').disabled=row.quantity===0;
    container.querySelector('[data-delta="1"]').disabled=row.quantity===99;
    selectionName='Your custom bundle';
    updateSummary();
  });

  $('#reset-button').addEventListener('click',()=>{rows=products.map(product=>makeRow(product));selectionName='Your custom bundle';renderRows();});
  document.querySelectorAll('[data-size-guide]').forEach(trigger=>trigger.addEventListener('click',event=>{
    event.preventDefault();
    if(!$('#size-dialog').open)$('#size-dialog').showModal();
  }));
  document.querySelectorAll('[data-close]:not([data-customer-close])').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
  document.querySelectorAll('dialog:not([data-customer-dialog])').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog){const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();}}));
  function reviewBundle(){
    const quote=getQuote();
    $('#review-content').innerHTML=quote.quantity?rows.filter(row=>row.quantity>0).map(row=>{const product=getProduct(row.id);return `<div class="review-line"><img src="${imageFor(product,row.color)}" alt="${product.name} socks"><div><strong>${product.name} Merino Socks</strong><small>${row.color} / ${row.size} · ${row.quantity} ${row.quantity===1?'pair':'pairs'}</small></div><span>${money(row.quantity*product.price)}</span></div>`;}).join('')+`<div class="review-prices"><div class="price-line"><span>Regular price</span><span>${money(quote.subtotal)}</span></div><div class="price-line saving"><span>Your savings (${quote.discountPercent}%)</span><span>−${money(quote.savings)}</span></div><div class="total-line"><span>${quote.quantity} pairs · bundle total</span><strong>${money(quote.total)}</strong></div></div>`:'<p>Your bundle is waiting. Choose a set or add your favorite styles to get started.</p>';
    resetCheckoutButton();
    $('#checkout-note').textContent='Shipping and taxes are calculated at checkout.';
    $('#checkout-note').removeAttribute('role');
    $('#review-dialog').showModal();
  }
  function resetCheckoutButton(){
    const quote=getQuote();
    $('#checkout-button').disabled=!quote.quantity;
    $('#checkout-button').textContent=`Checkout · ${money(quote.total)}`;
  }
  function clearCheckoutReturn(){
    returnToBuilderPending=false;
    try{window.sessionStorage.removeItem(checkoutReturnKey);}catch{}
  }
  function showBuilderAfterCheckout(){
    if(!returnToBuilderPending)return;
    clearCheckoutReturn();
    if($('#review-dialog').open)$('#review-dialog').close();
    resetCheckoutButton();
    // Replace only the fragment, retaining the private preview URL and its key.
    window.history.replaceState(window.history.state,'','#builder');
    const heading=$('#builder-heading');
    heading.tabIndex=-1;
    heading.focus({preventScroll:true});
    $('#builder').scrollIntoView({block:'start',behavior:'instant'});
  }
  $('#review-button').addEventListener('click',reviewBundle);
  $('#checkout-button').addEventListener('click',()=>{
    try{
      $('#checkout-button').disabled=true;
      $('#checkout-button').textContent='Opening checkout…';
      returnToBuilderPending=true;
      try{window.sessionStorage.setItem(checkoutReturnKey,'1');}catch{}
      if(BundleCatalogue.openCheckout(rows)==='new-tab'){
        showBuilderAfterCheckout();
      }
    }catch(error){
      clearCheckoutReturn();
      $('#checkout-note').textContent=error.message;
      $('#checkout-note').setAttribute('role','alert');
      resetCheckoutButton();
    }
  });

  const rowsElement=$('#product-rows');
  let restoreTimer;
  function restorePage(){
    // History traversal may restore inputs after pageshow, without change events.
    // Repaint once traversal finishes, using the same model for every control.
    window.clearTimeout(restoreTimer);
    restoreTimer=window.setTimeout(()=>{
      if(!rowsElement.isConnected)return;
      renderRows();
      resetCheckoutButton();
      showBuilderAfterCheckout();
    },0);
  }
  // Shopify's editor can remount this section without navigating the page.
  window.HywellBundleRestoreCleanup?.();
  window.addEventListener('pageshow',restorePage);
  window.HywellBundleRestoreCleanup=()=>{
    window.removeEventListener('pageshow',restorePage);
    window.clearTimeout(restoreTimer);
  };
  renderRows();
};
window.HywellBundleMount();
document.addEventListener('shopify:section:load',event=>{if(event.target.querySelector('#hywell-bundle-page'))window.HywellBundleMount();});
